<template>
  <div>
    <div class="column-acoes">
      <el-dropdown trigger="click" :disabled="this.desabilitaAbrirAcoes">
        <span :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}`" class="el-dropdown-link" :class="{ 'is-disabled': this.desabilitaAbrirAcoes }">Ações <i class="el-icon-more"></i></span>
        <el-dropdown-menu slot="dropdown" class="acoes-dropdown">
          <el-dropdown-item v-for="(acao, index) in columnAcoes" :key="index">
            <el-button v-show="('show' in acao)? acao.show : true" type="text" @click="acao.func(row)">{{acao.label}}</el-button>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="text"></el-button>
    </div>
    <ModalEnvio
      :open.sync="mostraEnvio"
      title="Selecionar Envio"
      width="523px"
      @close="mostraEnvio = false"
      :close-on-click-modal="true"
      :destroy-on-close="true"
      :payloadWidget="()=>{return carregaPayloadWidget(row)}"
    >
    </ModalEnvio>
  </div>
</template>
<style scoped>
.column-acoes {
  text-align: right;
  margin: 5px 0 0;
}
.column-acoes ul {
  padding: 0;
}
.grid-content {
  min-height: 36px;
}
.is-disabled {
  color: #bbb !important;
  pointer-events: none !important;
}
.el-dropdown-link i {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  font-size: 13px;
  line-height: 13px;
}
.el-dropdown-link {
  color: #006FB9;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  cursor: pointer;
  outline: none;
}
.acoes-dropdown {
  margin: 2px -20px -1px -75px;
  padding: 0;
}
.el-dropdown-menu.acoes-dropdown .el-dropdown-menu__item {
  padding: 0 20px;
}
</style>
<script>
import { mapGetters, mapState } from 'vuex'
import { EnumCanalAtendimentoOrigem } from '@/constants/EnumCanalAtendimentoOrigem'
import ModalEnvio from '@/components/ModalEnvio/ModalEnvio'
import { preloadWidget } from '@/views/55/PreLoadWidget55'

export default {
  name: 'AcoesUtilizacao',
  props: ['column', 'row'],
  components: { ModalEnvio },
  data () {
    return {
      mostraEnvio: false,
      payloadWidget: {}
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo', 'canalAtendimentoOrigem']),
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade', 'frameId', 'embedJson']),
    columnAcoes () {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return this.menuMosiaDesk
        default:
          return { }
      }
    },
    menuMosiaDesk () {
      const payloadMenu = []
      if (
        this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioChatWidget ||
        this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioEmailWidget ||
        this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioWhatsappWidget
      ) {
        payloadMenu.push({ label: 'Enviar', func: this.abreDialogEnvio })
      }
      return payloadMenu
    },
    desabilitaEnviar () {
      return !(this.opcaoEnvio !== '' && (this.escolhasEnvio.length > 0))
    },
    desabilitaAbrirAcoes () {
      return (!this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioChatWidget && !this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioEmailWidget && !this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioWhatsappWidget)
    }
  },
  methods: {
    async abreDialogEnvio () {
      this.mostraEnvio = true
    },
    carregaPayloadWidget (row) {
      return preloadWidget(
        row,
        this.funcionalidade,
        this.embedJson.atendimento.tokenAtendente
      )
    }
  }
}
</script>
